(function ($) {

	$(document).ready(function() {
        
        /* Sidr */
        $('#mobile-trigger').sidr({
            side: 'right',
            name: 'sidr',
            displace: false,
            source : function() {
                var sidrHtml;
                
                sidrHtml = '<div id="mobile-menu">';
                
                sidrHtml += '<span class="sidr__close" aria-label="Close Menu"><span class="screen-reader-text">Close Menu</span></span>';
                sidrHtml += '<div class="sidr__logo">' + $('.site-header .site-logo').html() + '</div>';
                
                sidrHtml += '<div class="sidr__inner">';
                
                sidrHtml += '<div class="sidr__mainnav">' + $('.main-navigation').html() + '</div>';
                
                if($('.site-navigation .sub-navigation').length){
                    sidrHtml += '<ul class="sidr__subnav">' + $('.site-navigation .sub-navigation').html() + '</ul>';
                }
                
                sidrHtml += '</div>';
                sidrHtml += '</div>';
                    
                return sidrHtml;
            },
            onOpen: function() {
                //alert('test');
                $('body').prepend('<div class="sidr-overlay"></div>');
            },
            onOpenEnd: function() {
                $('body').css({
                    "position": "fixed",
                    "left": "0",
                    "top": "0",
                    "width": "100%"
                });
            },
            onClose: function() {
                $('.sidr-overlay').remove();
            },
            onCloseEnd: function() {
                $('body').css({
                    "position": "relative",
                    "left": "auto",
                    "top": "auto",
                    "width": "100%"
                });
            }
        });
        $('.menu-item-has-children .arrow').click(function(e) {
            e.preventDefault();
            $(this).toggleClass('active').next().slideToggle();
        });
        $('.sidr__close').click(function() {
            $.sidr('close','sidr');
        });
        
	});
})(jQuery);